export default __webpack_public_path__ + "static/brand-figure-43560ff56cd2b4af84df893bc8f545e4.svg";